RoundDetailCtrl = ($scope, $location, $filter, flash, LocationTrackingService, roundInfo, playersAnalysis, goalSettings, allMembersAnalysis, RoundDetailService, $analytics, $routeParams, userInfo) ->

  $analytics.eventTrack('DTL_loaded')
  RoundDetailService.savePreviousLocation(roundInfo.id)

  $scope.roundInfo = roundInfo
  $scope.playersAnalysis = playersAnalysis
  $scope.goalSettings = goalSettings
  $scope.allMembers = allMembersAnalysis
  $scope.hideHeader = false
  $scope.hideLabel = false

  if $routeParams.hide_header == '1'
    $scope.hideHeader = true
  if ($routeParams.user_id != undefined && $routeParams.event_id != undefined)
    $scope.hideLabel = true
  if ($routeParams.user_id != undefined && userInfo? && userInfo.user_id != $routeParams.user_id)
    $scope.hideLabel = true

  $scope.navigateBackToPreviousLink = ->
    transitionFromAnalysis = localStorage.getItem("TRANSITION_FROM_ANALYSIS")
    if transitionFromAnalysis && transitionFromAnalysis == '1'
      return $location.url("/analysis")

    if $routeParams.event_id != undefined
      $location.url("/group-event/#{$routeParams.event_id}/ranking")
    else
      #User click 'X' button -> must track the first recent history
      #ex: dashboard -> round-detail -> score-registration, press back button then click 'X' -> go to dashboard
      $location.path(RoundDetailService.getPreviousLocation(roundInfo.id))
      RoundDetailService.clearPreviousLocation(roundInfo.id)

  $scope.navigateToEnterScorePage = ->
    if roundInfo.agency_request_id
      flash.error $filter('translate')('AGENCY_DENINED')
      return

    $location.path("/score-registration/#{$scope.roundInfo.id}")

RoundDetailCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  'flash'
  'LocationTrackingService'
  'roundInfo'
  'playersAnalysis'
  'goalSettings'
  'allMembersAnalysis'
  'RoundDetailService'
  '$analytics'
  '$routeParams'
  'userInfo'
]

module.exports = RoundDetailCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/round-detail-controller.coffee